import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps, ScreenProperty, SiteRecommendedUseTypesProps } from '../../../../../../../@types/types'
import ChipsGroup from '../../../../../../common/inputs/chipsGroup/ChipsGroup'
import { getSiteRecommendedUseTypes } from '../../../../../../../services/domain/getSiteRecommendedUseTypes'
import ToggleSwitch from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'
import { AbstractScreenValidationResult } from '../../../../../../../@types/validation-types'
import { SCREEN_OTHER_FACILITIES, SCREENS } from '../../../../../../../services/domain/wizardScreens'

const screen = SCREENS[SCREEN_OTHER_FACILITIES]

export interface SiteRecommendedUseTypesAdditionalProps {
  siteRecommendedUseTypes: SiteRecommendedUseTypesProps[]
}

const SiteRecommendedUseTypes: React.FC<
  FieldProps<AbstractScreenValidationResult> & SiteRecommendedUseTypesAdditionalProps
> = ({ insertionData, siteRecommendedUseTypes, onChange, screenName, doReset }) => {
  const { t } = useTranslation()
  const [hasSiteRecommendedUseTypes, setRecommendedUseTypes] = useState(false)
  const doToggle = () => {
    setRecommendedUseTypes((prev) => !prev)
    hasSiteRecommendedUseTypes && callReset()
  }
  useEffect(() => {
    insertionData.siteRecommendedUseTypes &&
      Object.values(insertionData.siteRecommendedUseTypes).some((v) => v) &&
      setRecommendedUseTypes(true)
  }, [insertionData.siteRecommendedUseTypes])

  const callReset = () => {
    const resetSiteRecommendedUseTypes: ScreenProperty[] = []
    siteRecommendedUseTypes.forEach((type) => {
      resetSiteRecommendedUseTypes.push({
        screen: screen.name,
        property: `siteRecommendedUseTypes.${type.property}`,
      })
    })
    doReset && doReset(resetSiteRecommendedUseTypes)
  }
  return (
    <div className='grid-item'>
      <div className='grid-item margin-bottom-l'>
        <ToggleSwitch
          id='recommended-use-types-toggle'
          alignment='custom'
          propertyName='custom'
          label={
            <span>
              {t('wizard.screen.otherFacilities.siteRecommendedUseTypes.toggleLabel', 'Recommended use types toggle')}
            </span>
          }
          value={hasSiteRecommendedUseTypes}
          onChange={doToggle}
        />
      </div>
      {hasSiteRecommendedUseTypes && (
        <>
          <span className='font-body-medium-bold'>
            {t('wizard.screen.otherFacilities.siteRecommendedUseTypes.chipsLabel', 'Recommended Use types')}
          </span>
          <ChipsGroup
            id='site-recommended-use-types'
            className='margin-top-s palm-one-whole lap-one-whole'
            chipRelatedClassName='palm-one-whole'
            containerClassName='one-half'
            features={getSiteRecommendedUseTypes(siteRecommendedUseTypes, insertionData)}
            translation='wizard.screen.otherFacilities.siteRecommendedUseTypes.typesLabels.'
            onChange={(property, value) => onChange({ screen: screenName, property }, value)}
          />
        </>
      )}
    </div>
  )
}

export default SiteRecommendedUseTypes
